const MEMBERS = {
  SET_MEMBERS_QUERY: 'SET_MEMBERS_QUERY',
  SET_CUSTOMEMAILS_QUERY: 'SET_CUSTOMEMAILS_QUERY',
  SET_CUSTOMEMAILS_SENT_QUERY: 'SET_CUSTOMEMAILS_SENT_QUERY',
  SET_MODAL_PROGRAM: 'SET_MODAL_PROGRAM',
  SET_MODAL_VIEW: 'SET_MODAL_VIEW',
  SET_MEMBERS_STATS_QUERY: 'SET_MEMBERS_STATS_QUERY',
  SET_PENDING_MEMBERS_QUERY: 'SET_PENDING_MEMBERS_QUERY',
};

export default MEMBERS;
